// consts
import { SHIFTS } from 'app/config/prescription_shifts';
// utils
import { setHours, setMinutes, setSeconds } from 'date-fns';

const setTimePerShift = function (date, shiftId) {
  const { MORNING, AFTERNOON, NIGHT } = SHIFTS;

  const isMorningShift = parseInt(shiftId) === MORNING;
  const isAfternoonShift = parseInt(shiftId) === AFTERNOON;
  const isNightShift = parseInt(shiftId) === NIGHT;

  let hourToBeSetted = 9;
  let minuteToBeSetted = 0;

  if (isMorningShift) {
    hourToBeSetted = 9;
  }
  if (isAfternoonShift) {
    hourToBeSetted = 15;
  }
  if (isNightShift) {
    hourToBeSetted = 20;
  }

  return setHours(setMinutes(setSeconds(date, 0), minuteToBeSetted), hourToBeSetted);
};

export default setTimePerShift;
